import CitationItemRecord from "models/view-models/citations/citation-item-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

interface CitationsQueryParams {
    token: string | null | undefined;
}

const baseEndpoint = "citations";
const key = baseEndpoint;

const CitationsService = {
    useListQuery: QueryHookFactory.useListQuery<
        CitationItemRecord,
        CitationsQueryParams
    >(key, CitationItemRecord, baseEndpoint),
};

export default CitationsService;
